import { useAppSelector } from '@store/index';
import { getIfInMeeting } from '@store/meeting/meeting.slice';
import { getIfShowWaitingRoom } from '@store/ui/ui.slice';

import EnteringPage from './EnteringPage/EnteringPage';
import MeetingPage from './MeetingPage';

const Room = () => {
  const inMeeting = useAppSelector(getIfInMeeting);
  const showWaitingRoom = useAppSelector(getIfShowWaitingRoom);

  /**
   * 会议室页面和进会页共享一个路由
   *
   * 1. 通过 meeting.slice 里的 ifInMeeting 状态来标识有没有成功进会
   * 2. 在 /r/${meetingCode} 链接里，只要没有成功进会都会进入到 entering 页
   */
  return inMeeting && !showWaitingRoom ? <MeetingPage /> : <EnteringPage />;
};

export default Room;
